/* eslint-disable max-len */
import styled from 'styled-components';
import WithdrawMoneyDarkIcon from '../../assets/images/money-withdraw-icon.svg';
import WithdrawMoneyLightIcon from '../../assets/images/money-withdraw-icon-light.svg';

const WithdrawMoneyIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${WithdrawMoneyDarkIcon}") no-repeat left center`
      : `url("${WithdrawMoneyLightIcon}") no-repeat left center`};
  background-size: 34px 27px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 27px;
  width: 34px;
`;

export default WithdrawMoneyIcon;
